import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataAppSetting: [],
  keyword: {
    appSetting: ""
  },
  loading: false,
  sortConfig: {
    key: "createdAt",
    direction: "DESC",
  },
};

export const AppSetting = createSlice({
  name: "app_setting",
  initialState,
  reducers: {
    ChangeDataAppSetting: (state, action) => {
      state.dataAppSetting = action.payload;
    },
    ChangeKeyword: (state, action) => {
      const { menu, value } = action.payload;
      state.keyword[menu] = value;
    },
    ChangeLoading: (state, action) => {
      state.loading = action.payload;
    },
    ChangeSortConfig: (state, action) => {
      state.sortConfig = action.payload;
    },
  },
});

export const {
  ChangeDataAppSetting,
  ChangeKeyword,
  ChangeLoading,
  ChangeSortConfig,
} = AppSetting.actions;

export default AppSetting.reducer;